import { render, staticRenderFns } from "./OrdersListFilters.vue?vue&type=template&id=605ef7a2&"
import script from "./OrdersListFilters.vue?vue&type=script&lang=js&"
export * from "./OrdersListFilters.vue?vue&type=script&lang=js&"
import style0 from "./OrdersListFilters.vue?vue&type=style&index=0&id=605ef7a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports